import { render, staticRenderFns } from "./equipments-list.vue?vue&type=template&id=45d798ed&scoped=true&"
import script from "./equipments-list.vue?vue&type=script&lang=ts&"
export * from "./equipments-list.vue?vue&type=script&lang=ts&"
import style0 from "./equipments-list.vue?vue&type=style&index=0&id=45d798ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d798ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VIcon})
